import React, { useState } from 'react';
import { clsx } from 'clsx';
import { Gauge } from '@/shared/ui';
import type { AdsAudit } from '../api/campaignsApi';
import { AdsAuditPlatformBreakdownModal } from './AdsAuditPlatformBreakdownModal';
import styles from './AdsAuditCard.module.css';

type Tone = 'general' | 'strategy';

interface Props {
  audit: AdsAudit;
  tone?: Tone;
}

export function AdsAuditCard({ audit, tone = 'general' }: Props) {
  const [isBreakdownOpen, setBreakdownOpen] = useState(false);
  // The click-through only adds value when there's something extra to show.
  const hasPerPlatformBreakdown = !!audit.breakdown?.platforms;

  const gauge = <Gauge score={audit.score} size={96} />;

  return (
    <div className={styles.card}>
      {hasPerPlatformBreakdown ? (
        <button
          type="button"
          className={styles.gaugeButton}
          onClick={() => setBreakdownOpen(true)}
          aria-label="Show per-platform score breakdown"
        >
          {gauge}
          <span className={styles.gaugeHint}>View breakdown</span>
        </button>
      ) : (
        gauge
      )}
      <div className={styles.body}>
        <div className={styles.header}>
          <span className={styles.title}>Ads Score</span>
          <span
            className={clsx(
              styles.toneBadge,
              tone === 'general' ? styles.toneGeneral : styles.toneStrategy,
            )}
          >
            {tone === 'general' ? 'General Scan' : 'Strategy-Aligned'}
          </span>
        </div>
        {audit.summary && <div className={styles.summary}>{audit.summary}</div>}
      </div>
      {hasPerPlatformBreakdown && (
        <AdsAuditPlatformBreakdownModal
          audit={audit}
          isOpen={isBreakdownOpen}
          onClose={() => setBreakdownOpen(false)}
        />
      )}
    </div>
  );
}
